export default __webpack_public_path__ + "static/media/ueesLogo.69dec780.jfif";